import React, { useState, useEffect } from "react";
import {
  Button,
  DialogContent,
  Grid,
  InputAdornment,
  TextField,
  withStyles
} from "@material-ui/core";
import Alert from '@material-ui/lab/Alert';
import { Person, Lock} from '@material-ui/icons';
import { useDispatch, useSelector } from "react-redux";
import RedtailCrmLogo from './assets/RedtailCrmLogo.svg';
import redtailAction from "../../../../../../actions/redtail.action";


const styles = (theme) => ({
  content: {
    width: 360,
    minHeight: 480,
    padding: theme.spacing(3),
    margin: "0 auto",
  },
  message: {
    fontSize: theme.typography.fontSize,
  },
  logo: {
    filter: "grayscale(100%) opacity(75%)",
    width: "100%",
    marginBottom: theme.spacing(2),
  },
  control: {
    width: "100%",
    marginBottom: theme.spacing(2),
  },
});

const RedtailLogin = ({ classes }) => {

  const dispatch = useDispatch();

  const [requestSuccess, message, resetPasswordUrl] = useSelector(({ redtail }) => [redtail.requestSuccess, redtail.message, redtail.resetPasswordUrl]);

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  useEffect(() => {
    dispatch(redtailAction.resetPassword());
  }, []);

  const isValid = username.length > 0 && password.length > 0;

  const handleUsername = (e) => setUsername(e.target.value);

  const handlePassword = (e) => setPassword(e.target.value);

  const handleSignIn = () => {
    const payload = {
      username,
      password,
    }
    dispatch(redtailAction.linkAccount(payload));
  }

  const handleKeyUp = (e) => {
    if (isValid && e.keyCode === 13) handleSignIn();
  };

  const handleResetPassword = () => {
    if (resetPasswordUrl) {
      window.open(resetPasswordUrl);
    }
  }

  return (
    <DialogContent>
      { message && (
        <Alert
          severity={requestSuccess ? "success" : "error"}
          className={classes.message}
        >
          { message }
        </Alert>
      )}
      <Grid
        container
        direction="column"
        justify="center"
        alignItems="center"
        className={classes.content}
      >
        <img
          className={classes.logo}
          src={RedtailCrmLogo}
          alt="Redtail CRM Logo"
        />
        <TextField
          name="username"
          label="Username"
          onChange={handleUsername}
          onKeyUp={handleKeyUp}
          autoFocus
          required
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Person />
              </InputAdornment>
            ),
          }}
          className={classes.control}
        />
        <TextField
          name="password"
          label="Password"
          type="password"
          onChange={handlePassword}
          onKeyUp={handleKeyUp}
          required
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Lock />
              </InputAdornment>
            ),
          }}
          className={classes.control}
        />
        <Button
          variant="contained"
          color="primary"
          size="small"
          disabled={!isValid}
          className={classes.control}
          onClick={handleSignIn}
        >
          Sign In
        </Button>
        <Button
          color="primary"
          size="small"
          disabled={!resetPasswordUrl}
          onClick={handleResetPassword}
          className={classes.control}
        >
          Forgot your password
        </Button>
      </Grid>
    </DialogContent>
  );
};

export default withStyles(styles)(RedtailLogin);



// WEBPACK FOOTER //
// ./src/containers/Dashboard/components/ImportClientModal/components/RedtailLogin/index.jsx